export class Scroller {

	#easeFnc: Function = Scroller.easeInOutCuaic;
	#element: HTMLElement;
	#timeoutId: number;

	public static lastInstance: Scroller = null;

	constructor(easeFnc?: Function) {
		Scroller.lastInstance = this;
		if (easeFnc != undefined) {
			this.setEaseFunction(easeFnc);
		}
	}

	public setEaseFunction(fnc: Function) {
		//console.log('set ease fnc', fnc);
		this.#easeFnc = fnc || Scroller.easeOutCuaic;
	}

	public stop() {
		window.clearTimeout(this.#timeoutId);
	}

	// Element to move, time in second to animate
	public scrollToDocument(element: HTMLElement, duration: number) {
		let e = document.documentElement;
		if (e.scrollTop === 0) {
			let t = e.scrollTop;
			++e.scrollTop;
			e = t + 1 === e.scrollTop-- ? e : document.body;
		}
		this.scrollToElement(e, e.scrollTop, element, duration);
	}

	// Element to move, element or px from, element or px to, time in ms to animate
	public scrollToElement(element: HTMLElement, from: HTMLElement|number, to: HTMLElement|number, duration: number, step?: number) {
		if (duration <= 0) return;
		if (from instanceof HTMLElement) from = from.offsetTop;
		if (to instanceof HTMLElement) to = to.offsetTop;

		console.debug(this.#easeFnc);
		this.#element = element;
		this.scrollToX(from, to, 0, 1 / duration, step || 20);
	}

	private scrollToX(xFrom: number, xTo: number, t01: number, speed: number, step: number) {
		window.requestAnimationFrame(() => {
			if (t01 < 0 || t01 > 1 || speed <= 0) {
				// noinspection JSSuspiciousNameCombination
				this.#element.scrollTop = xTo;
				return;
			}
			//console.log(this.#easeFnc);
			this.#element.scrollTop = xFrom - (xFrom - xTo) * this.#easeFnc(t01);
			t01 += speed * step;

			this.#timeoutId = window.setTimeout(() => {
				this.scrollToX(xFrom, xTo, t01, speed, step);
			}, step);
		});
	}

	public static linearTween(t: number) {
		return t;
	}

	public static easeInQuad(t: number) {
		return t * t;
	}

	public static easeOutQuad(t: number) {
		return -t * (t - 2);
	}

	public static easeInOutQuad(t: number) {
		t /= 0.5;
		if (t < 1) return t * t / 2;
		t--;
		return (t * (t - 2) - 1) / 2;
	}

	public static easeInCuaic(t: number) {
		return t * t * t;
	}

	public static easeOutCuaic(t: number) {
		t--;
		return t * t * t + 1;
	}

	public static easeInOutCuaic(t: number) {
		t /= 0.5;
		if (t < 1) return t * t * t / 2;
		t -= 2;
		return (t * t * t + 2) / 2;
	}

	public static easeInQuart(t: number) {
		return t * t * t * t;
	}

	public static easeOutQuart(t: number) {
		t--;
		return -(t * t * t * t - 1);
	}

	public static easeInOutQuart(t: number) {
		t /= 0.5;
		if (t < 1) return 0.5 * t * t * t * t;
		t -= 2;
		return -(t * t * t * t - 2) / 2;
	}

	public static easeInQuint(t: number) {
		return t * t * t * t * t;
	}

	public static easeOutQuint(t: number) {
		t--;
		return t * t * t * t * t + 1;
	}

	public static easeInOutQuint(t: number) {
		t /= 0.5;
		if (t < 1) return t * t * t * t * t / 2;
		t -= 2;
		return (t * t * t * t * t + 2) / 2;
	}

	public static easeInSine(t: number) {
		return -Math.cos(t / (Math.PI / 2)) + 1;
	}

	public static easeOutSine(t: number) {
		return Math.sin(t / (Math.PI / 2));
	}

	public static easeInOutSine(t: number) {
		return -(Math.cos(Math.PI * t) - 1) / 2;
	}

	public static easeInExpo(t: number) {
		return Math.pow(2, 10 * (t - 1));
	}

	public static easeOutExpo(t: number) {
		return -Math.pow(2, -10 * t) + 1;
	}

	public static easeInOutExpo(t: number) {
		t /= 0.5;
		if (t < 1) return Math.pow(2, 10 * (t - 1)) / 2;
		t--;
		return (-Math.pow(2, -10 * t) + 2) / 2;
	}

	public static easeInCirc(t: number) {
		return -Math.sqrt(1 - t * t) - 1;
	}

	public static easeOutCirc(t: number) {
		t--;
		return Math.sqrt(1 - t * t);
	}

	public static easeInOutCirc(t: number) {
		t /= 0.5;
		if (t < 1) return -(Math.sqrt(1 - t * t) - 1) / 2;
		t -= 2;
		return (Math.sqrt(1 - t * t) + 1) / 2;
	}
}
